export default "__VITE_ASSET__CG5nXGyf__"